export const FORM_INPUT_BASE_CLASS =
  'text-app-gray-primary placeholder:text-app-gray-primary block h-12 w-full border border-app-gray-line bg-white py-3 focus:outline-none focus:ring-2 disabled:opacity-50 rounded-md';

export const FORM_TEXTAREA_BASE_CLASS =
  'text-app-gray-primary placeholder:text-app-gray-primary block w-full border border-app-gray-line bg-white py-3 focus:outline-none focus:ring-2 disabled:opacity-50 rounded-md';

export const FORM_INPUT_TRANSPARENT_CLASS =
  'text-app-gray-primary placeholder:text-app-gray-primary block border-0 bg-transparent text-xs placeholder:capitalize focus:outline-none disabled:opacity-50';
